import React from 'react'
import './About.css'

export const About: React.FC = () => {
    return (
        <div className="about">
            <div className="about-content">
                <section className="about-story">
                    <div className="about-story-content">
                        <h1>Our Story</h1>
                        <p>
                            Don't eat rocks. We rock.
                        </p>

                    </div>
                </section>
            </div>
        </div>
    )
}
